import React from "react";
import { cn } from "@/lib/utils";

// Renders one of the NYAYYAKSHA inline animations as an isolated iframe asset
// (served from /anim/<slug>.html). Isolation keeps each animation's CSS/JS from
// colliding with the app. Each asset honours prefers-reduced-motion internally.
export function AnimationFrame({ slug, title, height = 240, maxWidth = 460, className }) {
  return (
    <div className={cn("w-full", className)} data-testid={`anim-${slug}`}>
      <iframe
        title={title || slug}
        src={`${process.env.PUBLIC_URL || ""}/anim/${slug}.html`}
        loading="lazy"
        scrolling="no"
        className="mx-auto block w-full border-0 bg-transparent"
        style={{ height, maxWidth }}
      />
    </div>
  );
}
